exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-signup-tsx": () => import("./../../../src/templates/signup.tsx" /* webpackChunkName: "component---src-templates-signup-tsx" */)
}

